// extracted by mini-css-extract-plugin
export default {"btnAdd":"HandlingStatusRegister_btnAdd__RVffo","iconActive":"HandlingStatusRegister_iconActive__9Ejnf","icon":"HandlingStatusRegister_icon__BR5Jc"};